import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { INTAKE_QUESTIONNAIRES_API_BASE } from '../../constants';

import type { IIntakeQuestionnaireGeneralInfo } from '../../types';
import type { UpdateIntakeGeneralInfoPayload } from './types';

export function createIntakeGeneralThunks() {
  return {
    updateIntakeGeneralInfo: updateIntakeGeneralInfo(),
  };
}

function updateIntakeGeneralInfo() {
  return createAsyncThunk<IIntakeQuestionnaireGeneralInfo, UpdateIntakeGeneralInfoPayload>(
    'intakeQuestionnaire/updateIntakeGeneralInfo',
    async ({ intakeQuestionnaireId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/general_info`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}
